/// User will get here after entering a credit card details and this page will poll for status of the order from the server

import './orderStatusPage.css';

import React from 'react';
import { withTranslation } from 'react-i18next';

import Parent from '../parent';
import { constants } from '../constants/constants';
import { BllinkLogger } from '../utils/bllink_loggers';
import CacheData from '../utils/cacheData';
import { GAEvent } from '../google_analytics/google_analytics';

import logo from '../../images/logo.svg'
import Print from "../../images/print.svg";

import { OrderStatusTitle } from './orderStatusTitle';
import { OrderStatusConfirmationInfo } from './orderStatusConfirmationInfo';
import { OrderStatusDetails } from './orderStatusDetails';
import Header from '../header';
import { store } from '../../store/store';
import { changeBuildingID } from '../../store/buildings/slice';
import {fetchManagerBuildingData} from "../../store/buildings/actions";


export class OrderStatusPage extends Parent {

    loadingStarted = false;

    constructor(props) {
        super(props);
        document.title = props.t('titles.confirmation_page');

        const tenantDetails = CacheData.fetchCache('tenantDetails');
        let tenantEmail = tenantDetails?.email; // todo take from server

        this.state = this.newStatusForCart({
            cartID: props.match.params.cartID,
            hideUnsuccessful: true,
            tenantEmail: tenantEmail,
        });

        BllinkLogger.info(`new state`, this.state);
        this.clearTheVisitedTabsCache();
    }

    clearTheVisitedTabsCache(){
        CacheData.delete('visitedTabs');
    }

    checkIfOpenedInIframe() {
        //this is in case this page is opened in iframe (relevant for bitPage)
        if (window.self !== window.top) {
            window.postMessage('redirectToOrderStatusPage', '*');
        }
    }

    async loadManagerData() {
        this.client.autheticated && await store.dispatch(fetchManagerBuildingData({ buildingID: this.state.buildingID, options : { urlParams: { skipDisabledCheck: true } }}));
    }

    async componentDidMount() {
        this.startLoader()
        this.checkIfOpenedInIframe();
        this.isViewedAsManager = await this.isLoggedIn();
        await this.afterLoadForCart(this.state, {...this.props, hideUnsuccessful: true, isStatusPage: true});
        await this.clearSelectedMonthsCache();
        if (!this.state.isExpense) {
            await this.loadManagerData();
        }
        store.dispatch(changeBuildingID(this.state.buildingID));
        this.endLoader();
    }

    clearSelectedMonthsCache(){
        // clear the on going and debt cache (for part pay)
        const apartmentDetails = this.state && this.state.apartmentNumber && this.state.buildingID;
        if (apartmentDetails){
            let buildingID = this.state.buildingID;
            let apartmentNumber = this.state.apartmentNumber;
            if (buildingID && apartmentNumber){
                CacheData.delete('onGoingSelectedPayments', {buildingID: buildingID, apartmentNumber: apartmentNumber});
                CacheData.delete('debtSelectedPayments', {buildingID: buildingID, apartmentNumber: apartmentNumber});
            }
        }
    }

    onPrintClick = (e) => {
        e.preventDefault();
        GAEvent(constants.GoogleAnalytics.Events.clicks, 'Print', 1, 'printConfirmationPage');
        window.print();
    }

    renderLogo(){

        const managementDetails = this.state.managementCompanyDetails;
        const managedByCompany = managementDetails.logo;
        // to avoid initial load of bllink logo and only then company logo
        const hasInformationAboutCompany = (managementDetails.notManaged || managementDetails.logo);

        let confirmationLogo = null;
        if (managedByCompany) {
            confirmationLogo = (
                <div>
                    {this.renderManagementCompanyLogo(managementDetails)}
                    <h4>{managementDetails.name}</h4>
                </div>
            )
        } else {
            if (hasInformationAboutCompany) {
                confirmationLogo = <img alt="blink" className="img-responsive" src={logo}/>
            }
        }

        return  confirmationLogo

    }

    renderManagementCompanyLogo(managementDetails){
        if (managementDetails.url){
            return (
                <a href={`${managementDetails.url}`} target='_blank' rel="noopener noreferrer">
                    <img alt="logo" className="img-responsive-logo" src={managementDetails.logo}/>
                </a>
            )
        }else{
            return <img alt="logo" className="img-responsive-logo" src={managementDetails.logo}/>
        }
    }

    render() {
        const { t } = this.props;
        this.setBodyClasses(constants.backgroundOptions.confirmation);

        //https://app.asana.com/0/1196545425570329/1198956650306898
        // Should show loader instead of text when changing tabs or refreshing the page
        const stillLoadingFromBackend = !this.state.fetchedFromBackend;
        if (stillLoadingFromBackend){
            if (!this.loadingStarted) {
                this.loadingStarted = true;
                this.startLoader();
            }
        } else {
            if (this.loadingStarted) {
                this.loadingStarted = false;
                this.endLoader();
            }
        }

        const hasConfirmationDetails = (
            constants.PaymentPlanDetailsStatus.ALL_SUCCESS.includes(this.state.paymentDetails.state)
        );
        const hasTenantEmail = this.state.tenantEmail;
        const confirmationSent = hasTenantEmail && hasConfirmationDetails;

        BllinkLogger.info(`order status render state is `, this.state)

        return (
            <div className={!this.isViewedAsManager ? 'main-content' : ''}>
                {
                    !this.isViewedAsManager && (
                        <Header />
                    )
                }
                <div id="section-to-print" className={this.isViewedAsManager ? 'mt-5' : ''}>
                    <section>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 last-border-line">
                                    <div className="main-sec-top-c">
                                        <h2>{t('payments.confirmation_title')}
                                            <a
                                                href="/"
                                                className="pdff"
                                                id="js-print-page"
                                                onClick={this.onPrintClick}
                                            >
                                                <img src={Print} alt="print"/>
                                            </a>
                                        </h2>
                                        {this.renderLogo()}
                                        { confirmationSent &&
                                        <h5>{t('payments.confirmation_email')}</h5>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 txt_Head">
                                    <OrderStatusTitle
                                        address={this.state.address}
                                        vendorDetails={this.state.vendorDetails}
                                        isExpense={this.state.isExpense}
                                    />
                                    { !stillLoadingFromBackend &&
                                    <OrderStatusConfirmationInfo
                                        paymentDetails={this.state.paymentDetails}
                                        cartID={this.props.match.params.cartID}
                                        isExpense={this.state.isExpense}
                                    />
                                    }
                                    { stillLoadingFromBackend &&
                                    <div className="mid-sec-Div d-flex">
                                        <div className="container p-dept-section loading-content"/>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </section>

                    { !stillLoadingFromBackend &&
                    <section>
                        <OrderStatusDetails
                            paymentDetails={this.state.paymentDetails}
                            tenantDetails={this.state.tenantDetails}
                            buildingPayerDetails={this.state.buildingPayerDetails}
                            oneTimePaymentsInstallments={this.state.oneTimePaymentsInstallments}
                            pastPaymentsInstallments={this.state.pastPaymentsInstallments}
                            onGoingInstallments={this.state.onGoingInstallments}
                            nextMonthsPaymentsData={this.state.nextMonthsPaymentsData}
                            tenantCommission={this.state.tenantCommission}
                            onChange={this.render}
                            isExpense={this.state.isExpense}
                        />
                    </section>
                    }
                </div>
            </div>
        )
    }
}

export default withTranslation()(OrderStatusPage);
